export default __webpack_public_path__ + "b58f6395f01deede29bbb69fcf4044f0.png";